import { SafeHtml } from '@angular/platform-browser';
import { SelectItem } from 'primeng/api/selectitem';

export class past_medical_history_data {
    id: number;
    name: string;
}

export class family_history {
    name: string;
    data: string[];
}

export class Allergy {
    id: number;
    name: string;
    reaction: string;
}

export class Medication {
    id: number;
    name: string;
    dose: string;
    times_per_day: string;
    instructions: string;
}

export class medicalHistoryUiEdit {
    others: {
        data: medicalHistoryApiData;
        more_medical: boolean;
        medical_history_value: string;
        none_selected_medical_history: boolean;
        medical_history_row: number[];
        add_temp_medication: Medication;
        edit_temp_medication: Medication;
        medication_edit_id: number;
        medication_columns: string[];
        add_temp_allergy: Allergy;
        edit_temp_allergy: Allergy;
        allergy_edit_id: number;
        allergy_columns: string[];
        delete_header_name: string;
        years: SelectItem[];
        year: number;
    };
    api_data: medicalHistoryApiData;
}

export class SocialHistory_Alcohol {
    selected: string;
    data: {
        drinks_per_week: string;
        year_of_quitting: number;
    };
}

export class SocialHistory_Smoking {
    selected: string;
    data: {
        number_of_packs_per_day: string;
        numbers_of_years_smoked: string;
        year_of_quitting: number;
    };
}

export class SocialHistory {
    smoking: SocialHistory_Smoking;
    alcohol: SocialHistory_Alcohol;
}

export class Social_History_Data extends SocialHistory {
    social_history_data: SafeHtml;
}

export class medicalHistoryOthersData {
    is_exist_current_medical_problem: boolean;
    is_exist_past_surgical_history: boolean;
    empty_medical_history: boolean;
    none_selected_medical_history: boolean;
    family_history_options_data: SelectItem[];
}

export class medicalHistoryApiData {
    currentMedicalProblems: string;
    past_medical_history_data: pastMedicalHitory_item[];
    selected_past_medical_history_data: pastMedicalHitory_item[];
    past_surgical_history_data: string;
    medications: Medication[];
    allergies: Allergy[];
    social_history: SocialHistory;
    // selected_social_history: SocialHistory;
    family_history: family_history[];
    selected_family_history: family_history[];
    other_data: medicalHistoryOthersData;
}

export class pastMedicalHitory_item extends past_medical_history_data {
    selected: boolean;
}


export class PatientMedicalHistoryEdit {
    patient_guid: string;
    past_medical_history_data: pastMedicalHitory_item[];
    past_surgical_history_data: string;
    social_history: SocialHistory;
    family_history: family_history[];
    allergies: Allergy[];
    medications: Medication[];
    current_medical_problems: string;
}
